import type { ValuesType } from '@fifa-bsm/bo-frontend-shared/utils/types';

export const TicketDistributionStatus = Object.freeze({
    TO_DISTRIBUTE: 'to-distribute',
    DISTRIBUTING: 'distributing',
    DISTRIBUTED: 'distributed',
    CANCELLED: 'cancelled',
    CANCELLING: 'cancelling',
} as const);

export type ITicketDistributionStatus = ValuesType<typeof TicketDistributionStatus>;
